export class AppConstant {
    static readonly LoginToken = 'token';
    static readonly LoginRequestModel = 'LoginRequestModel';
    static readonly USER = 'user';
    static readonly LOGIN_TIME = 'loginTime';
    static readonly CAPTCHA_BASE64 = 'captchaBase64';
}
